import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { IdleTimer } from './idleTimer.component';
import { IdleTimeoutActions } from '../../../modules/idleTimeout/idleTimeout.redux';
import { selectIsBookingActive, selectBookingStep } from '../../../modules/booking';
import { selectIsIdle } from '../../../modules/idleTimeout/idleTimeout.selectors';

const mapStateToProps = createStructuredSelector({
  isIdle: selectIsIdle,
  isBookingActive: selectIsBookingActive,
  bookingStep: selectBookingStep,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      idleChange: IdleTimeoutActions.idleChange,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(IdleTimer);
